import Btn from '../elements/Btn';
import Checklist from '../elements/Checklist';
import Hero from '../elements/Hero'
import Title from '../elements/Title'
import HeroBannerService from '../img/HeroBannerService.png';
import BookingImage from "../img/booking.png";
import BookingImage1 from "../img/booking1.png";
import BookingImage3 from "../img/booking3.png";
import TriImage from '../elements/TriImage'; 
import TrustedPartners from '../elements/TrustedPartners';
import AdditionalServices from "../elements/AdditionalServices";
import HappyCustomers from '../elements/HappyCustomers';
import ExploreAll from '../elements/ExploreAll';
import Newsletter from '../elements/Newsletter';
import Footer from '../elements/Footer';
import FreeQuote from '../elements/FreeQuote';
import QuickServices from '../elements/QuickServices';
import user from '../img/testimonial.png';

export default function Services() {

    const service = [
        {
            title: "Moving, Packing &Unpacking Services", 
            des: "Sometimes packing can feel like a real chore, and even be a big undertaking for your family. Whether it's a single item or your entire home, our team is happy to offer complete packing and unpacking services."
        },
        {
            title: "All Sizes Boxes Moving Supplies",
            des: "From boxes of all sizes to tape to keep those boxes secure, to packing peanuts and bubble wrap, we have the high-quality moving supplies you need to protect all your belongings."
        },
        { 
            title: "Comprehensive Moving Checklist",
            des: "How many steps are there to moving? The more you think about it, the more steps there seem to be. When you hire the HUNKS, you'll also receive a comprehensive moving checklist to help with your big move."
        },
        {
            title: "Comprehensive Moving Checklist",
            des: "How many steps are there to moving? The more you think about it, the more steps there seem to be. When you hire the HUNKS, you'll also receive a comprehensive moving checklist to help with your big move."
        }
    ]

    const customers = [
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        }, 

    ]

    return <> 
        <Hero bg={HeroBannerService} >
            <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri' >
                <div className='row align-items-end' >
                    <div className='col-lg-6 pb-3 pb-lg-5 mt-3' >
                        <div class="discountTag m-auto d-flex align-items-center m-md-0 ">
                            <div class="badge badge-primary">NEW</div>
                            <p>GET 30% OFF on Moving Packing Services Today!</p>
                        </div>
                        <div className='banner_content py-0 pt-4' >
                            <Title mainClass="text-start"
                                titleclass="lg text-white mb-2 text-center text-lg-start"
                                desclass=" text-center text-lg-start mt-3 mb-2"
                                title={<>Affordable Local & Long Distance Services!</>}
                                des="ExquisiteMoves is the Full-Service Moving & Packing Company with Over 15+ Years of Experience!"/>
                            <Checklist
                                list={["Moving Services", "Junk Removal", "Donation", "Labour"]}
                                class="my-4 text-white ps-0 ps-sm-4 ps-lg-0" col="col-sm-6"
                                liststyle="normal" />
                            <Btn class="mb-0 mb-lg-4 m-lg-0 m-auto d-table"
                                arrow={true}
                                wave={true}
                                href="#"
                            >Explore All Our Services</Btn>
                        </div>
                    </div>
                    <div className='col-lg-6 ps-lg-5' >
                        <TriImage mainclass="mt-3" 
                        img1={BookingImage1}
                        img2={BookingImage}
                        img3={BookingImage3} 
                        />
                    </div>
                </div>
            </div>
        </Hero>
        <TrustedPartners />
        <AdditionalServices title="Additional Services"
        des="Whether You’re Looking For A Little Help Loading And Unloading Your Moving Truck, Or You Want A Full-Service Move Including Packing, Unpacking, Arranging, And Everything In Between, Our Team Is Ready To Help You. We Promise To Provide 100% Satisfaction With Every Project."
         data={service} />
        <ExploreAll />
        <HappyCustomers customers={customers} /> 
        <QuickServices />
        <FreeQuote />   
        <Newsletter />  
        <Footer /> 
    </>
}